module.exports = __webpack_public_path__ + "static/media/icons8-whatsapp-384.620d41c6.png";